module.exports = __webpack_public_path__ + "img/sneek-2.29a4ef6a.jpg";